import { actionCreator } from "@ps/utils";
import { AnyAction } from "redux";
import { ActionTypes } from "./actionTypes";

export const toggleEditMode = (payload: string): AnyAction =>
  actionCreator(ActionTypes.TOGGLE_EDIT_MODE, payload);
